import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'user-category',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'user-category',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'user-category',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'user-category',
  action: ActionType.UPDATE,
};

export const UserCategory = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
